import React from "react";
import { Controller, Control } from "react-hook-form";
import { FormGroup, Input } from "@cofano/cck";
import { Language } from "imports/Utils";
import DatePicker from "components/cck/DatePicker";
import { CargoForm } from "types/index";

const Deepsea = ({ control }: {
	control: Control<CargoForm>,
}) => {
	return (
		<React.Fragment>
			<FormGroup label={Language("CARGO_DEEPSEA_SHIP_NAME_LOADING")} labelPlacement="left-center" overflow="hidden">
				<Controller
					name="deepseaShipNameLoading"
					control={control}
					render={({ field }) => <Input {...field} />} />
			</FormGroup>

			<FormGroup label={Language("CARGO_DEEPSEA_SHIP_IMO_LOADING")} labelPlacement="left-center" overflow="hidden">
				<Controller
					name="deepseaShipImoLoading"
					control={control}
					render={({ field }) => <Input {...field} type="number" />} />
			</FormGroup>

			<FormGroup label={Language("CARGO_DEEPSEA_VOYAGE_NUMBER_LOADING")} labelPlacement="left-center" overflow="hidden">
				<Controller
					name="deepseaVoyageNumberLoading"
					control={control}
					render={({ field }) => <Input {...field} />} />
			</FormGroup>

			<FormGroup label={Language("CARGO_DEEPSEA_ETA_LOADING")} labelPlacement="left-center" overflow="hidden">
				<Controller
					name="deepseaEtaLoading"
					control={control}
					render={({ field }) => <DatePicker {...field} showTimeInput />} />
			</FormGroup>

			<FormGroup label={Language("CARGO_DEEPSEA_SHIP_NAME_DISCHARGING")} labelPlacement="left-center" overflow="hidden">
				<Controller
					name="deepseaShipNameDischarging"
					control={control}
					render={({ field }) => <Input {...field} />} />
			</FormGroup>

			<FormGroup label={Language("CARGO_DEEPSEA_SHIP_IMO_DISCHARGING")} labelPlacement="left-center" overflow="hidden">
				<Controller
					name="deepseaShipImoDischarging"
					control={control}
					render={({ field }) => <Input {...field} type="number" />} />
			</FormGroup>

			<FormGroup label={Language("CARGO_DEEPSEA_VOYAGE_NUMBER_DISCHARGING")} labelPlacement="left-center" overflow="hidden">
				<Controller
					name="deepseaVoyageNumberDischarging"
					control={control}
					render={({ field }) => <Input {...field} />} />
			</FormGroup>

			<FormGroup label={Language("CARGO_DEEPSEA_ETA_DISCHARGING")} labelPlacement="left-center" overflow="hidden">
				<Controller
					name="deepseaEtaDischarging"
					control={control}
					render={({ field }) => <DatePicker {...field} showTimeInput />} />
			</FormGroup>

			<FormGroup label={Language("CARGO_DEEPSEA_ESTIMATE_DISCHARGE")} labelPlacement="left-center" overflow="hidden">
				<Controller
					name="deepseaEstimateDischarge"
					control={control}
					render={({ field }) => <DatePicker {...field} showTimeInput />} />
			</FormGroup>
		</React.Fragment>
	);
};

export default Deepsea;
